import {Injectable} from '@angular/core';
import {MenuType} from "../models";

@Injectable({
    providedIn: 'root'
})
export class IconService {
    constructor() {
    }

    setIcon(val: MenuType | number): string {
        switch (val) {
            case "MU":
                return "/assets/img/top_menu/menu.svg";
            case "MS":
                return "/assets/img/top_menu/menu_service.svg";
            case "MI":
                return "/assets/img/top_menu/menu_fitters.svg";
            case "MP":
                return "/assets/img/top_menu/menu_manufacturer.svg";
            default:
                return "/assets/img/id_icons/" + val + ".svg";
        }
    }
}
